(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-backup-originale-down"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)')
      .addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.hide();
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.reveal();
    } else if (scrollTop <= this.headerBounds.top) {
      this.reset();
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden');
    this.header.classList.add('shopify-section-header-sticky');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }
}

customElements.define('sticky-header', StickyHeader);


/* ------------------------------
   DESKTOP HOVER NAVIGATION SAFE
-------------------------------- */

class HeaderHoverNavigation {
  constructor() {
    this.desktopMedia = window.matchMedia('(min-width: 990px)');
    this.navContainer = document.querySelector('.header__custom-nav.medium-hide.small-hide');
    this.closeDelay = 180;
    this.closeTimers = new WeakMap();

    if (!this.navContainer) return;

    this.navItems = Array.from(
      this.navContainer.querySelectorAll('.header__custom-nav-item > details')
    );

    this.desktopMedia.addEventListener('change', () => this.onMediaChange());
    this.onMediaChange();
  }

  onMediaChange() {
    if (!this.navItems.length) return;

    if (this.desktopMedia.matches) {
      this.enableDesktopBehavior();
    } else {
      this.disableDesktopBehavior();
    }
  }

  enableDesktopBehavior() {
    this.navItems.forEach((detailsEl) => {
      if (detailsEl.dataset.hoverBound === 'true') return;

      const summary = detailsEl.querySelector('summary');
      if (!summary) return;

      const openMenu = () => {
        this.clearCloseTimer(detailsEl);
        this.navItems.forEach((item) => {
          if (item !== detailsEl) {
            this.clearCloseTimer(item);
            item.removeAttribute('open');
          }
        });
        detailsEl.setAttribute('open', '');
      };

      const closeMenu = () => {
        this.setCloseTimer(detailsEl);
      };

      detailsEl.addEventListener('mouseenter', openMenu);
      detailsEl.addEventListener('mouseleave', closeMenu);

      detailsEl._hoverHandlers = { openMenu, closeMenu };
      detailsEl.dataset.hoverBound = 'true';
    });
  }

  disableDesktopBehavior() {
    this.navItems.forEach((detailsEl) => {
      detailsEl.removeAttribute('open');

      if (detailsEl.dataset.hoverBound !== 'true') return;
      if (!detailsEl._hoverHandlers) return;

      const { openMenu, closeMenu } = detailsEl._hoverHandlers;

      detailsEl.removeEventListener('mouseenter', openMenu);
      detailsEl.removeEventListener('mouseleave', closeMenu);
      this.clearCloseTimer(detailsEl);

      detailsEl.dataset.hoverBound = 'false';
      detailsEl._hoverHandlers = null;
    });
  }

  setCloseTimer(detailsEl) {
    this.clearCloseTimer(detailsEl);
    const timer = setTimeout(() => {
      detailsEl.removeAttribute('open');
      this.closeTimers.delete(detailsEl);
    }, this.closeDelay);
    this.closeTimers.set(detailsEl, timer);
  }

  clearCloseTimer(detailsEl) {
    const timer = this.closeTimers.get(detailsEl);
    if (timer) {
      clearTimeout(timer);
      this.closeTimers.delete(detailsEl);
    }
  }
}

new HeaderHoverNavigation();

  } catch(e) { console.error(e); }
})();
})();
